import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJupyterComponent } from './simple-icons-jupyter.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJupyterComponent ],
    exports:      [ SimpleIconsJupyterComponent ],
    bootstrap:    []
})
export class SimpleIconsJupyterModule {}
